export const CHANNEL_SOURCE = {
    casinoClient: 'CASINO_CLIENT',
    partyJackpotToaster: 'PARTY_JACKPOT_TOASTER',
    omg: 'OMG',
    myAccount: 'MY_ACCOUNT',
    uploadDocuments: 'UPLOAD_DOCUMENTS',
    registration: 'REGISTRATION',
    pendingPlay: 'PENDING_PLAY',
    pendingAction: 'PENDING_ACTION',
    geoLocationRetry: 'GEO_LOCATION_RETRY',
    geoLocation: 'GEO_LOCATION',
    rich: 'RICH',
    about_popup: 'ABOUT_POPUP',
    cashier:"CASHIER"
}

export const CHANNEL_ELEMENTS = {
    depositButton: 'deposit_button',
    withdrawButton: 'withdraw_button',
    uploadDocumentsButton: 'upload_documents_button',
    transactionHistoryButton: 'transaction_history_button',
    retryButton: 'retry_button',
    plusButton: 'plus_button',
    urlParam: 'url_param',
    deepLink: 'deep_link',
    floatingIcon: 'floating_icon',
    controlCenterHeaderButton: 'safezone_header_button',
    controlCenterTooltip: 'control_center_tooltip',
    controlCenterUsefulLink: 'safezone_useful_link',
    gamesLimitsLobbyButton: 'games_limits_lobby_button',
    gamesLimitsGameButton: 'games_limits_game_button',
    omgAction:"omg_action",
    cashierAction:"cashier_action",
}

export const DISPLAY_MESSAGE_IDS = {
    sofRequired: 100,
    retryCloseDrawerMessage: 101,
    psRedirectFocusDialog: 102,
    timeSpentReminder: 104,
    nightLimitWarning: 105,
    nightLimitKick: 106,
    lugasCooldown:108,
    lugasActiveOnAnotherOperator:109,
    lugasLogout:110,
    loginMessage:112,
    realityCheckGermany: 113
}

export const DISPLAY_MESSAGE_NAMES = {
    DISRUPTIVE_WARNING_MESSAGE_NAME: "DisruptiveWarningMessage",
    DISRUPTIVE_KICKOFF_MESSAGE_NAME: "DisruptiveKickOffMessage",
    LUGAS_COOLDOWN_MESSAGE_NAME:"LugasCoolingPeriod",
    LUGAS_ACTIVE_MESSAGE_NAME:"LugasParallelPlaying",
    LUGAS_LOGOUT_MESSAGE_NAME:"LugasLogout",
    REALITY_CHECK_GERMANY_MESSAGE_NAME: "RealityCheck",
    LOGIN_MESSAGE: "LoginMessage"
}

export const ACTION_TAKEN_NAMES = {
    CONFIRM_ACTION: "confirm",
    CANCEL_ACTION: "cancel",
}